/**
 * Categories select / dropdown
 */

import { fetchAll } from "@/services/collection/categories/api";
import { CategoryId } from "@/services/collection/categories/types";
import { gettext } from "@/services/translation";

export const ValueAllCategories = 0;
export type CategoriesAll = 0;
export const ValueFavouriteCategories = -1;
export type CategoryFavourites = -1;
export type CategoryIdOrAll = CategoryId | CategoriesAll;
export type SelectValue = undefined | typeof ValueAllCategories | typeof ValueFavouriteCategories | number;

export type Option = {
  label: string;
  value: Exclude<SelectValue, undefined>;
};

export async function createOptions(addOptionAll = false, addOptionFavourite = false): Promise<Option[]> {
  return fetchAll().then((categories) => {
    const options: Option[] = categories.map((category) => ({
      label: category.name,
      value: category.id,
    }));

    if (addOptionFavourite) {
      const optionFavourite = {
        label: gettext.$gettext("Oblíbené kategorie"),
        value: ValueFavouriteCategories,
      };
      options.unshift(optionFavourite);
    }

    if (addOptionAll) {
      const optionAll = {
        label: gettext.$gettext("Všechny kategorie"),
        value: ValueAllCategories,
      };
      options.unshift(optionAll);
    }

    return options;
  });
}
